import coverImg from "assets/images/v117/cover.webp"
import titleImg from "assets/images/v117/title.webp"

export const v117Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
